import {TooltipProvider} from '@continuum/ui';
import {Router} from '~/foundation/router';
import {ErrorScreen} from '~/components/error-screen';
import {PostHogProvider} from '~/lib/analytics';
import {PostHogErrorBoundary} from 'posthog-js/react';

export const App = () => {
  return (
    <PostHogProvider>
      <PostHogErrorBoundary fallback={() => <ErrorScreen showRefresh />}>
        <TooltipProvider>
          <Router />
        </TooltipProvider>
      </PostHogErrorBoundary>
    </PostHogProvider>
  );
};
